function $a6df9c40ba402dc9$export$7138c24907de3954(pathname) {
    const { protocol: protocol, host: host } = new URL(window.location.href);
    return new URL(pathname, `${protocol}//${host}`);
}
function $a6df9c40ba402dc9$export$3d7cd8ed57263b30() {
    const refs = {};
    function el(...args) {
        const tag = args[0];
        let attrs;
        let content;
        if (typeof args[1] === "object" && !Array.isArray(args[1])) {
            attrs = args[1];
            content = args[2];
        } else content = args[1];
        let element;
        if ([
            "svg",
            "path"
        ].includes(tag)) element = document.createElementNS("http://www.w3.org/2000/svg", tag);
        else element = document.createElement(tag);
        if (Array.isArray(content)) for (const item of content)element.append(item);
        else if (typeof content !== "undefined") element.textContent = content.toString();
        if (attrs) {
            for(const attr in attrs)if (attrs.hasOwnProperty(attr)) {
                if (typeof refs === "object" && attr === "ref") refs[attrs[attr]] = element;
                else element.setAttribute(attr, attrs[attr]);
            }
        }
        return element;
    }
    return [
        el,
        refs
    ];
}
function $a6df9c40ba402dc9$export$751f361fd4ccee93(url, rerender = true) {
    history.pushState(null, "", url);
    if (rerender) window.dispatchEvent(new CustomEvent("popstate"));
}
function $a6df9c40ba402dc9$export$23981ac8d9cec36(url, rerender = true) {
    history.replaceState(null, "", url);
    if (rerender) window.dispatchEvent(new CustomEvent("popstate"));
}
class $a6df9c40ba402dc9$export$77cea355fa80b5f4 {
    constructor(data){
        this.data = data;
        this.listeners = [];
    }
    get value() {
        return this.data;
    }
    set value(data) {
        this.data = data;
        for (const listener of this.listeners)if (typeof listener === "function") listener();
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
}
function $a6df9c40ba402dc9$export$d2e637738f5e6ae8() {
    const items = document.cookie.split(';'); // Split the string into individual cookie strings
    const cookies = {};
    for (const item of items){
        const pair = item.trim().split("=");
        if (pair.length !== 2) continue;
        const key = decodeURIComponent(pair[0]);
        const value = decodeURIComponent(pair[1]);
        cookies[key] = value;
    }
    return cookies;
}
function $a6df9c40ba402dc9$export$ac21a6921280ab9c() {
    const cookies = $a6df9c40ba402dc9$export$d2e637738f5e6ae8();
    if (typeof cookies.userId === "undefined") {
        $a6df9c40ba402dc9$export$23981ac8d9cec36("/login");
        throw new Error("Session expired");
    }
}



function $3b89005fd0863ad1$var$isToday(d) {
    const now = new Date();
    return now.getDate() === d.getDate() && now.getMonth() === d.getMonth() && now.getFullYear() == d.getFullYear();
}
function $3b89005fd0863ad1$export$2e2bcd8739ae039(year, month, el, onDateClicked) {
    const d = new Date(year, month - 1);
    const dayMarker = el("div", {
        class: "day-marker"
    }, [
        el("div", "SUN"),
        el("div", "MON"),
        el("div", "TUE"),
        el("div", "WED"),
        el("div", "THU"),
        el("div", "FRI"),
        el("div", "SAT")
    ]);
    const calendarBody = [];
    for(let i = 0; i < d.getDay(); i++)calendarBody.push(el("div"));
    while(d.getMonth() == month - 1){
        const dateItem = el("div", {
            class: "date-tile",
            "data-year": d.getFullYear(),
            "data-month": d.getMonth() + 1,
            "data-dom": d.getDate()
        }, [
            el("div", {
                class: $3b89005fd0863ad1$var$isToday(d) ? "today" : ""
            }, `${d.getDate()}`),
            el("div", {
                ref: `cal-${d.getDate()}`,
                class: "reservation"
            })
        ]);
        dateItem.addEventListener("click", onDateClicked);
        calendarBody.push(dateItem);
        d.setDate(d.getDate() + 1);
    }
    if (d.getDay() !== 0) for(let i = d.getDay(); i < 7; i++)calendarBody.push(el("div"));
    const calendarElem = el("div", {
        class: "calendar",
        ref: "calendar"
    }, [
        dayMarker,
        el("div", {
            class: "calendar-body",
            ref: "calendarBody"
        }, calendarBody)
    ]);
    return calendarElem;
}



class $9d473bfbaad64c2f$export$2e2bcd8739ae039 {
    #root;
    #comboBox;
    #listBox;
    defaultValue;
    #onBlur;
    #minTime;
    #el;
    constructor({ defaultValue: defaultValue = $9d473bfbaad64c2f$export$2e2bcd8739ae039.recommendedTime, onBlur: onBlur = null, minTime: minTime = null }){
        const [el] = (0, $a6df9c40ba402dc9$export$3d7cd8ed57263b30)();
        this.#el = el;
        this.#root = this.#el("div", {
            class: "time-input"
        });
        this.defaultValue = defaultValue;
        this.#onBlur = onBlur;
        this.#minTime = minTime;
        this.#createComboBox();
        this.#createListBox();
        this.#createOptions();
        this.#comboBox.addEventListener("click", (event)=>{
            event.preventDefault();
            this.#showListBox(event);
        });
        document.addEventListener("click", (event)=>{
            if (!this.#comboBox.contains(event.target)) this.#hideListBox();
        });
    }
    static pad(n) {
        const nStr = n.toString();
        return nStr.length < 2 ? `0${nStr}` : nStr;
    }
    static recommendedTime() {
        const current = new Date();
        let defaultHours = current.getHours();
        let defaultMinutes = 30;
        if (current.getMinutes() >= 30) {
            defaultHours += 1;
            defaultMinutes = 0;
        }
        if (defaultHours == 24) defaultHours = 0;
        return `${$9d473bfbaad64c2f$export$2e2bcd8739ae039.pad(defaultHours)}:${$9d473bfbaad64c2f$export$2e2bcd8739ae039.pad(defaultMinutes)}`;
    }
    static nextHour(time) {
        const values = time.split(":");
        const date = new Date();
        const hour = parseInt(values[0], 10);
        const minutes = parseInt(values[1], 10);
        date.setHours(hour + 1 > 23 ? hour : hour + 1);
        date.setMinutes(minutes);
        return `${$9d473bfbaad64c2f$export$2e2bcd8739ae039.pad(date.getHours())}:${$9d473bfbaad64c2f$export$2e2bcd8739ae039.pad(date.getMinutes())}`;
    }
    get root() {
        return this.#root;
    }
    get value() {
        return this.#comboBox.value;
    }
    set value(newValue) {
        this.#comboBox.value = newValue;
        this.#validate();
    }
    set minTime(value) {
        this.#minTime = value;
        this.#createOptions();
    }
    get minTime() {
        return this.#minTime;
    }
    #showListBox() {
        if (this.#listBox.classList.contains("hidden")) {
            this.#listBox.classList.remove("hidden");
            this.#onComboBoxInput();
        }
    }
    #hideListBox() {
        this.#listBox.classList.add("hidden");
    }
    #validate() {
        const value = this.#comboBox.value.trim();
        let tokens = value.split(":");
        let hours = NaN;
        let minutes = NaN;
        if (tokens.length === 2) {
            hours = parseInt(tokens[0], 10);
            minutes = parseInt(tokens[1], 10);
        } else if (tokens.length === 1) {
            hours = parseInt(tokens[0].substring(0, 2), 10);
            minutes = parseInt(tokens[0].substring(2, 4), 10);
        }
        if (Number.isNaN(hours) || Number.isNaN(minutes)) this.#comboBox.value = this.defaultValue();
        else {
            if (hours < 0 || hours > 23) this.#comboBox.value = this.defaultValue();
            else if (minutes < 0 || minutes > 60) this.#comboBox.value = this.defaultValue();
            else this.#comboBox.value = `${$9d473bfbaad64c2f$export$2e2bcd8739ae039.pad(hours)}:${$9d473bfbaad64c2f$export$2e2bcd8739ae039.pad(minutes)}`;
        }
    }
    #createComboBox() {
        this.#comboBox = this.#el("input", {
            type: "text",
            autocapitalize: "none",
            autocomplete: "off",
            role: "combobox",
            value: this.defaultValue()
        });
        this.#comboBox.addEventListener("keyup", this.#onComboBoxKeyUp.bind(this));
        this.#comboBox.addEventListener("keydown", this.#onComboBoxKeyDown.bind(this));
        this.#comboBox.addEventListener("focus", this.#showListBox.bind(this));
        this.#comboBox.addEventListener("blur", this.#onComboBoxBlur.bind(this));
        this.#root.appendChild(this.#comboBox);
    }
    #createListBox() {
        this.#listBox = this.#el("ul", {
            role: "listbox",
            class: "hidden"
        });
        this.#listBox.addEventListener("mouseover", this.#onListBoxMouseOver.bind(this));
        this.#listBox.addEventListener("click", this.#onListBoxClick.bind(this));
        this.#listBox.addEventListener("keydown", this.#onListBoxKeyDown.bind(this));
        this.#root.appendChild(this.#listBox);
    }
    #createOptions() {
        this.#listBox.innerHTML = "";
        for(let i = 0; i <= 23; i++)for(let j = 0; j < 60; j += 15){
            const li = this.#el("li", {
                tabindex: "-1"
            }, `${$9d473bfbaad64c2f$export$2e2bcd8739ae039.pad(i)}:${$9d473bfbaad64c2f$export$2e2bcd8739ae039.pad(j)}`);
            if (typeof this.#minTime === "string" && this.#minTime.localeCompare(li.textContent) > 0) continue;
            this.#listBox.appendChild(li);
        }
    }
    #onComboBoxKeyUp(event) {
        const options = this.#listBox.querySelectorAll("li");
        switch(event.key){
            case "ArrowUp":
            case "ArrowLeft":
            case "ArrowRight":
            case " ":
            case "Enter":
            case "Tab":
            case "Shift":
                break;
            case "ArrowDown":
                this.#showListBox();
                for(let i = 0; i < options.length; i++)if (options[i].classList.contains("highlight")) {
                    options[i].focus();
                    this.#comboBox.value = options[i].textContent;
                    break;
                }
                break;
            case "Escape":
                this.#hideListBox();
                break;
            default:
                this.#onComboBoxInput();
        }
    }
    #onComboBoxKeyDown(event) {
        switch(event.key){
            case "Enter":
                event.preventDefault();
            case "Tab":
                this.#hideListBox();
                break;
        }
    }
    #onComboBoxInput() {
        const currentInput = this.#comboBox.value.trim();
        const options = this.#listBox.querySelectorAll("li");
        let toHighlight = null;
        for(let i = 0; i < options.length; i++)if (options[i].classList.contains("highlight")) options[i].classList.remove("highlight");
        for(let i = 0; i < options.length; i++)if (options[i].textContent.trim() === currentInput) {
            toHighlight = options[i];
            break;
        }
        if (toHighlight === null) for(let i = 0; i < options.length; i++){
            const content = options[i].textContent.trim();
            if (content.startsWith(currentInput) || content.replaceAll(":", "").startsWith(currentInput)) {
                toHighlight = options[i];
                break;
            }
        }
        if (toHighlight !== null) {
            toHighlight.scrollIntoView({
                block: "center",
                container: "nearest"
            });
            toHighlight.classList.add("highlight");
        }
    }
    #onComboBoxBlur(event) {
        event.preventDefault();
        this.#validate();
        this.#onBlur();
    }
    #onListBoxMouseOver(event) {
        event.preventDefault();
        if (event.target.tagName === "LI") {
            const options = this.#listBox.querySelectorAll("li");
            for(let i = 0; i < options.length; i++)if (options[i].classList.contains("highlight")) options[i].classList.remove("highlight");
            event.target.classList.add("highlight");
        }
    }
    #onListBoxClick(event) {
        event.preventDefault();
        if (event.target.tagName === "LI") {
            this.#comboBox.value = event.target.textContent;
            this.#comboBox.focus();
            this.#hideListBox();
        }
    }
    #onListBoxKeyDown(event) {
        event.preventDefault();
        const options = this.#listBox.querySelectorAll("li");
        switch(event.key){
            case "ArrowUp":
                for(let i = 0; i < options.length; i++){
                    if (options[i].classList.contains("highlight")) {
                        if (options[i].previousElementSibling) {
                            options[i].classList.remove("highlight");
                            options[i].previousElementSibling.classList.add("highlight");
                            options[i].previousElementSibling.focus();
                            this.#comboBox.value = options[i].textContent;
                            break;
                        }
                    }
                }
                break;
            case "ArrowDown":
                for(let i = 0; i < options.length; i++){
                    if (options[i].classList.contains("highlight")) {
                        if (options[i].nextElementSibling) {
                            options[i].classList.remove("highlight");
                            options[i].nextElementSibling.classList.add("highlight");
                            options[i].nextElementSibling.focus();
                            this.#comboBox.value = options[i].textContent;
                            break;
                        }
                    }
                }
                break;
            case "Enter":
                for(let i = 0; i < options.length; i++)if (options[i].classList.contains("highlight")) {
                    this.#comboBox.value = options[i].textContent;
                    this.#hideListBox();
                    this.#comboBox.focus();
                    break;
                }
                break;
            case "Escape":
                this.#comboBox.focus();
                this.#hideListBox();
                break;
            case "Tab":
                this.#hideListBox();
                break;
            default:
                this.#comboBox.focus();
        }
    }
}



function $0566dfdfd66639f1$var$createSnackbar() {
    const [el] = (0, $a6df9c40ba402dc9$export$3d7cd8ed57263b30)();
    const root = el("div", {
        class: "snackbar-container"
    });
    function dispatch(text, context, duration = 5000) {
        const bar = el("div", {
            class: `snackbar ${context}`
        }, text);
        root.append(bar);
        if (duration !== 0) setTimeout(()=>{
            bar.remove();
        }, duration);
        return bar;
    }
    return {
        root: root,
        dispatch: dispatch
    };
}
var $0566dfdfd66639f1$export$2e2bcd8739ae039 = $0566dfdfd66639f1$var$createSnackbar();


function $1f14d7e062a1cc5a$var$createAddForm(el, refs, onSubmit, onDelete) {
    const nbsp = String.fromCharCode(160);
    const startTimeInput = new (0, $9d473bfbaad64c2f$export$2e2bcd8739ae039)({
        onBlur: ()=>{
            endTimeInput.minTime = startTimeInput.value;
            endTimeInput.value = (0, $9d473bfbaad64c2f$export$2e2bcd8739ae039).nextHour(startTimeInput.value);
        }
    });
    const endTimeInput = new (0, $9d473bfbaad64c2f$export$2e2bcd8739ae039)({
        defaultValue: ()=>(0, $9d473bfbaad64c2f$export$2e2bcd8739ae039).nextHour(startTimeInput.value),
        minTime: startTimeInput.value,
        onBlur: ()=>{
            if (startTimeInput.value.localeCompare(endTimeInput.value) > 0) endTimeInput.value = endTimeInput.defaultValue();
        }
    });
    const container = el("dialog", {
        ref: "addFormModal",
        class: "add-form-modal"
    }, [
        el("div", {
            class: "add-form-container"
        }, [
            el("div", {
                style: "display:flex"
            }, [
                el("div", [
                    el("h1", {
                        ref: "addFormRoomLabel",
                        class: "add-form-room-label"
                    }),
                    el("h2", {
                        ref: "addFormDateLabel",
                        class: "add-form-date-label"
                    }),
                    el("p", {
                        ref: "messageDisplay",
                        class: "add-form-message-display"
                    })
                ]),
                el("button", {
                    ref: "addFormCloseButton",
                    class: "icon-button fill"
                }, [
                    el("svg", {
                        height: "800px",
                        width: "800px",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                    }, [
                        el("path", {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z",
                            fill: "#0F1729"
                        })
                    ])
                ])
            ]),
            el("ul", {
                ref: "reservationList",
                class: "reservation-list"
            }, [
                el("li", "-- Empty --")
            ]),
            el("form", {
                ref: "addForm",
                class: "add-form"
            }, [
                el("input", {
                    ref: "roomInput",
                    type: "hidden"
                }),
                el("input", {
                    ref: "yearInput",
                    type: "hidden"
                }),
                el("input", {
                    ref: "monthInput",
                    type: "hidden"
                }),
                el("input", {
                    ref: "domInput",
                    type: "hidden"
                }),
                el("div", {
                    class: "time-range-group"
                }, [
                    startTimeInput.root,
                    el("div", `${nbsp}-${nbsp}`),
                    endTimeInput.root
                ]),
                el("textarea", {
                    ref: "descriptionInput",
                    placeholder: "Description..."
                }),
                el("div", [
                    el("button", {
                        ref: "addFormSubmitButton",
                        type: "submit",
                        class: "main-button"
                    }, "Save")
                ])
            ])
        ])
    ]);
    refs.addFormCloseButton.addEventListener("click", ()=>{
        refs.addFormModal.close();
    });
    refs.descriptionInput.addEventListener("input", (event)=>{
        if (event.target.value.length < 1) {
            refs.messageDisplay.classList.add("error");
            refs.messageDisplay.textContent = 'Description is required';
        } else refs.messageDisplay.textContent = '';
    });
    refs.addForm.addEventListener("submit", async (event)=>{
        event.preventDefault();
        const description = refs.descriptionInput.value;
        if (typeof description !== "string" || description.length < 1) {
            refs.messageDisplay.classList.add("error");
            refs.messageDisplay.textContent = 'Description is required';
            return;
        }
        try {
            refs.messageDisplay.classList.add("primary");
            refs.messageDisplay.textContent = "Loading...";
            await onSubmit({
                roomId: refs.roomInput.value,
                year: refs.yearInput.value,
                month: refs.monthInput.value,
                dom: refs.domInput.value,
                startTime: startTimeInput.value,
                endTime: endTimeInput.value,
                description: description
            });
            refs.descriptionInput.value = "";
            refs.addFormModal.close();
            (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch("Reservation saved", "primary", 3000);
        } catch (error) {
            refs.messageDisplay.classList.remove("primary");
            refs.messageDisplay.classList.add("error");
            refs.messageDisplay.textContent = `Error: ${error.message}`;
            setTimeout(()=>{
                refs.messageDisplay.textContent = "";
                refs.messageDisplay.classList.remove("error");
            }, 5000);
        } finally{
            if (refs.messageDisplay.classList.contains("primary")) {
                refs.messageDisplay.textContent = "";
                refs.messageDisplay.classList.remove("primary");
            }
        }
    });
    refs.reservationList.addEventListener("click", async (event)=>{
        event.preventDefault();
        const button = event.target.closest("button[data-id]");
        if (!button) return;
        const id = parseInt(button.dataset.id, 10);
        if (Number.isNaN(id)) return;
        try {
            refs.messageDisplay.classList.add("primary");
            refs.messageDisplay.textContent = "Loading...";
            await onDelete(id);
        } catch (error) {
            refs.messageDisplay.classList.remove("primary");
            refs.messageDisplay.classList.add("error");
            refs.messageDisplay.textContent = `Error: ${error.message}`;
            setTimeout(()=>{
                refs.messageDisplay.textContent = "";
                refs.messageDisplay.classList.remove("error");
            }, 5000);
        } finally{
            if (refs.messageDisplay.classList.contains("primary")) {
                refs.messageDisplay.textContent = "";
                refs.messageDisplay.classList.remove("primary");
            }
        }
    });
    return container;
}
var $1f14d7e062a1cc5a$export$2e2bcd8739ae039 = $1f14d7e062a1cc5a$var$createAddForm;



function $c79b291b2da299a3$export$2e2bcd8739ae039({ items: items = null, onSelect: onSelect = null }) {
    let selected = null;
    const [el, refs] = (0, $a6df9c40ba402dc9$export$3d7cd8ed57263b30)();
    const root = el("div", {
        class: "dropdown"
    }, [
        el("div", {
            ref: "control",
            class: "control"
        }, [
            el("div", {
                ref: "label",
                class: "label"
            }),
            el("div", {
                class: "arrow"
            }, [
                el("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, [
                    el("path", {
                        d: "M6 9L12 15L18 9",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    })
                ])
            ])
        ]),
        el("ul", {
            ref: "options",
            class: "options hidden"
        })
    ]);
    function setOptions(newItems) {
        items = newItems;
        refs.options.innerHTML = "";
        refs.options.append(...items.map((item)=>el("li", {
                "data-value": item.value.toString()
            }, item.label.toString())));
        if (items.length > 0) {
            selected = {
                label: items[0].label.toString(),
                value: items[0].value.toString()
            };
            refs.label.textContent = selected.label;
        }
    }
    function setSelected(value) {
        for (const item of items)if (item.value === value) {
            selected = {
                label: item.label.toString(),
                value: item.value.toString()
            };
            refs.label.textContent = selected.label;
        }
    }
    document.addEventListener("click", (event)=>{
        if (!root.contains(event.target)) refs.options.classList.add("hidden");
    });
    refs.control.addEventListener("click", (event)=>{
        event.preventDefault();
        refs.options.classList.toggle("hidden");
    });
    refs.options.addEventListener("click", (event)=>{
        if (event.target.dataset.value) {
            selected = {
                label: event.target.textContent,
                value: event.target.dataset.value
            };
            refs.label.textContent = selected.label;
            refs.options.classList.add("hidden");
            if (typeof onSelect === "function") onSelect(selected);
        }
    });
    if (items !== null) setOptions(items);
    return {
        root: root,
        setOptions: setOptions,
        setSelected: setSelected,
        get selected () {
            return selected;
        }
    };
}



let $212038711ef1a1fe$var$root = null;
function $212038711ef1a1fe$var$home() {
    const cookies = (0, $a6df9c40ba402dc9$export$d2e637738f5e6ae8)(document.cookie);
    if (typeof cookies.userId === "undefined") {
        (0, $a6df9c40ba402dc9$export$23981ac8d9cec36)("/login");
        return "";
    } else cookies.userId = parseInt(cookies.userId, 10);
    const [el, refs] = (0, $a6df9c40ba402dc9$export$3d7cd8ed57263b30)();
    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "Desember"
    ];
    let rooms = [];
    let reservations = [];
    const date = new Date();
    const url = new URL(window.location.href);
    const params = {
        roomId: parseInt(url.searchParams.get("room_id"), 10),
        year: parseInt(url.searchParams.get("year"), 10),
        month: parseInt(url.searchParams.get("month"), 10)
    };
    if (!Number.isNaN(params.year) && !Number.isNaN(params.month) && params.year >= 2000 && params.year <= 9999 && params.month >= 1 && params.month <= 12) {
        date.setFullYear(params.year);
        date.setMonth(params.month - 1);
    } else if (!Number.isNaN(params.year) || !Number.isNaN(params.month)) window.location.href = `${url.protocol}//${url.host}`;
    async function fetchRooms() {
        try {
            (0, $a6df9c40ba402dc9$export$ac21a6921280ab9c)();
            const response = await fetch(`/api/rooms`);
            if (response.ok) {
                const results = await response.json();
                return results;
            } else {
                const error = await response.json();
                (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch(`Error: ${error.message}`, "error");
                return [];
            }
        } catch (error) {
            (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch(`Error: ${error.message}`, "error");
            return [];
        }
    }
    async function fetchReservations(roomId, year, month) {
        try {
            (0, $a6df9c40ba402dc9$export$ac21a6921280ab9c)();
            const url = (0, $a6df9c40ba402dc9$export$7138c24907de3954)("/api/reservations");
            url.searchParams.set("room_id", roomId);
            url.searchParams.set("year", year);
            url.searchParams.set("month", month);
            const response = await fetch(url);
            if (response.ok) {
                const results = await response.json();
                return results;
            } else {
                const error = await response.json();
                (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch(`Error: ${error.message}`, "error");
                return [];
            }
        } catch (error) {
            (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch(`Error: ${error.message}`, "error");
            return [];
        }
    }
    function renderReservation() {
        for(let i = 1; i <= 31; i++)if (refs[`cal-${i}`]) refs[`cal-${i}`].innerHTML = "";
        for (const reservation of reservations){
            const item = el("p", `${reservation.start_time} - ${reservation.end_time} ${reservation.name}`);
            refs[`cal-${reservation.dom}`].append(item);
        }
    }
    function renderReservationForm(dom) {
        const elements = reservations.filter((item)=>item.dom === dom).map((item)=>el("li", [
                el("div", [
                    el("p", `${item.start_time} - ${item.end_time} ${item.name}`),
                    el("p", `${item.description ? item.description : "-"}`)
                ]),
                el("div", [
                    el("button", {
                        "data-id": item.id.toString(),
                        class: "icon-button small",
                        style: item.user_id === cookies.userId ? "" : "display: none"
                    }, [
                        el("svg", {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                        }, [
                            el("path", {
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M18 6V16.2C18 17.8802 18 18.7202 17.673 19.362C17.3854 19.9265 16.9265 20.3854 16.362 20.673C15.7202 21 14.8802 21 13.2 21H10.8C9.11984 21 8.27976 21 7.63803 20.673C7.07354 20.3854 6.6146 19.9265 6.32698 19.362C6 18.7202 6 17.8802 6 16.2V6M14 10V17M10 10V17"
                            })
                        ])
                    ])
                ])
            ]));
        refs.reservationList.innerHTML = "";
        if (elements.length > 0) refs.reservationList.append(...elements);
        else refs.reservationList.append(el("li", {
            style: "text-align: center"
        }, "-- Empty --"));
    }
    const roomDropdown = (0, $c79b291b2da299a3$export$2e2bcd8739ae039)({
        onSelect: onRoomSelect
    });
    const container = el("main", {
        class: "container"
    }, [
        el("header", [
            el("h1", "Peminjaman Ruang FS"),
            el("div", [
                el("p", `${cookies.email} (${cookies.name})`),
                el("button", {
                    ref: "logoutButton",
                    class: "icon-button"
                }, [
                    el("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                    }, [
                        el("path", {
                            d: "M21 12L13 12",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                        }),
                        el("path", {
                            d: "M18 15L20.913 12.087V12.087C20.961 12.039 20.961 11.961 20.913 11.913V11.913L18 9",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                        }),
                        el("path", {
                            d: "M16 5V4.5V4.5C16 3.67157 15.3284 3 14.5 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H14.5C15.3284 21 16 20.3284 16 19.5V19.5V19",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                        })
                    ])
                ])
            ])
        ]),
        el("nav", [
            el("div", {
                class: "calendar-control"
            }, [
                el("button", {
                    ref: "prevMonthBtn"
                }, [
                    el("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                    }, [
                        el("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            "d": "M14 5l-7 7 7 7"
                        })
                    ])
                ]),
                el("button", {
                    ref: "nextMonthBtn"
                }, [
                    el("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                    }, [
                        el("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            "d": "M10 5l7 7-7 7"
                        })
                    ])
                ]),
                el("p", [
                    el("span", {
                        ref: "monthLabel"
                    }, monthNames[date.getMonth()]),
                    el("span", `${String.fromCharCode(160)}`),
                    el("span", {
                        ref: "yearLabel"
                    }, date.getFullYear())
                ])
            ]),
            roomDropdown.root
        ]),
        (0, $3b89005fd0863ad1$export$2e2bcd8739ae039)(date.getFullYear(), date.getMonth() + 1, el, onDateClicked),
        (0, $1f14d7e062a1cc5a$export$2e2bcd8739ae039)(el, refs, onAddFormSubmit, onAddFormDelete)
    ]);
    function onDateClicked(event) {
        const dateElem = event.currentTarget;
        if (dateElem.dataset.dom) {
            const year = parseInt(dateElem.dataset.year, 10);
            const month = parseInt(dateElem.dataset.month, 10);
            const dom = parseInt(dateElem.dataset.dom, 10);
            renderReservationForm(dom);
            refs.roomInput.value = roomDropdown.selected.value;
            refs.yearInput.value = year;
            refs.monthInput.value = month;
            refs.domInput.value = dom;
            refs.addFormRoomLabel.textContent = roomDropdown.selected.label;
            refs.addFormDateLabel.textContent = `${dom} ${monthNames[month - 1]} ${year}`;
            refs.addFormModal.showModal();
        }
    }
    async function onAddFormSubmit(data) {
        try {
            (0, $a6df9c40ba402dc9$export$ac21a6921280ab9c)();
            const response = await fetch("/api/reservations", {
                method: "post",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
            if (response.ok) {
                const dom = parseInt(refs.domInput.value, 10);
                reservations = await response.json();
                renderReservation(reservations);
                renderReservationForm(dom);
            } else {
                const error = await response.json();
                throw error;
            }
        } catch (error) {
            throw error;
        }
    }
    async function onAddFormDelete(id) {
        try {
            (0, $a6df9c40ba402dc9$export$ac21a6921280ab9c)();
            const response = await fetch(`/api/reservations/${id}`, {
                method: "delete"
            });
            if (response.ok) {
                const dom = parseInt(refs.domInput.value, 10);
                reservations = await response.json();
                renderReservation(reservations);
                renderReservationForm(dom);
            } else {
                const error = await response.json();
                throw error;
            }
        } catch (error) {
            throw error;
        }
    }
    async function onRoomSelect() {
        const snack = (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch("Loading...", "primary", 0);
        (0, $a6df9c40ba402dc9$export$751f361fd4ccee93)(`/room/${roomDropdown.selected.value}/year/${date.getFullYear()}/month/${date.getMonth() + 1}`, false);
        reservations = await fetchReservations(roomDropdown.selected.value, date.getFullYear(), date.getMonth() + 1);
        renderReservation(reservations);
        snack.remove();
    }
    refs.nextMonthBtn.addEventListener("click", async ()=>{
        const snack = (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch("Loading...", "primary", 0);
        date.setMonth(date.getMonth() + 1);
        refs.monthLabel.textContent = monthNames[date.getMonth()];
        refs.yearLabel.textContent = date.getFullYear();
        const to = (0, $a6df9c40ba402dc9$export$7138c24907de3954)("/");
        to.searchParams.set("room_id", roomDropdown.selected.value);
        to.searchParams.set("year", date.getFullYear());
        to.searchParams.set("month", date.getMonth() + 1);
        (0, $a6df9c40ba402dc9$export$751f361fd4ccee93)(to.toString(), false);
        refs.calendar.replaceWith((0, $3b89005fd0863ad1$export$2e2bcd8739ae039)(date.getFullYear(), date.getMonth() + 1, el, onDateClicked));
        reservations = await fetchReservations(roomDropdown.selected.value, date.getFullYear(), date.getMonth() + 1);
        renderReservation(reservations);
        snack.remove();
    });
    refs.prevMonthBtn.addEventListener("click", async ()=>{
        const snack = (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch("Loading...", "primary", 0);
        date.setMonth(date.getMonth() - 1);
        refs.monthLabel.textContent = monthNames[date.getMonth()];
        refs.yearLabel.textContent = date.getFullYear();
        const to = (0, $a6df9c40ba402dc9$export$7138c24907de3954)("/");
        to.searchParams.set("room_id", roomDropdown.selected.value);
        to.searchParams.set("year", date.getFullYear());
        to.searchParams.set("month", date.getMonth() + 1);
        (0, $a6df9c40ba402dc9$export$751f361fd4ccee93)(to.toString(), false);
        refs.calendar.replaceWith((0, $3b89005fd0863ad1$export$2e2bcd8739ae039)(date.getFullYear(), date.getMonth() + 1, el, onDateClicked));
        reservations = await fetchReservations(roomDropdown.selected.value, date.getFullYear(), date.getMonth() + 1);
        renderReservation(reservations);
        snack.remove();
    });
    refs.logoutButton.addEventListener("click", async ()=>{
        await fetch("/logout");
        (0, $a6df9c40ba402dc9$export$23981ac8d9cec36)("/login");
    });
    (async ()=>{
        const snack = (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch("Loading...", "primary", 0);
        rooms = await fetchRooms();
        if (rooms.length > 0) {
            roomDropdown.setOptions(rooms.map((room)=>({
                    label: room.room_title,
                    value: room.id
                })));
            if (params.roomId) roomDropdown.setSelected(params.roomId);
            reservations = await fetchReservations(roomDropdown.selected.value, date.getFullYear(), date.getMonth() + 1);
            renderReservation(reservations);
        }
        snack.remove();
    })();
    return container;
}
var $212038711ef1a1fe$export$2e2bcd8739ae039 = ()=>{
    if ($212038711ef1a1fe$var$root === null) $212038711ef1a1fe$var$root = $212038711ef1a1fe$var$home();
    return $212038711ef1a1fe$var$root;
};





let $0f32c2d6739d5745$var$root = null;
function $0f32c2d6739d5745$var$login() {
    const [el, refs] = (0, $a6df9c40ba402dc9$export$3d7cd8ed57263b30)();
    const container = el("main", {
        class: "login-container"
    }, [
        el("div", {
            class: "login-form"
        }, [
            el("h1", "Peminjaman Ruang FS"),
            el("div", [
                el("button", {
                    ref: "loginButton"
                }, "Log in with Unpar account")
            ])
        ])
    ]);
    refs.loginButton.addEventListener("click", ()=>{
        window.location.href = "/auth/google";
    });
    return container;
}
var $0f32c2d6739d5745$export$2e2bcd8739ae039 = ()=>{
    const cookies = (0, $a6df9c40ba402dc9$export$d2e637738f5e6ae8)(document.cookie);
    if (typeof cookies.userId !== "undefined") {
        (0, $a6df9c40ba402dc9$export$23981ac8d9cec36)("/");
        return "";
    }
    if ($0f32c2d6739d5745$var$root === null) $0f32c2d6739d5745$var$root = $0f32c2d6739d5745$var$login();
    const url = new URL(window.location.href);
    if (url.searchParams.has("auth_error_code")) {
        const errorCode = url.searchParams.get("auth_error_code");
        switch(errorCode){
            case "unknown-1":
                (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch("Error: oauth2 authenticator refusing request", "error");
                break;
            case "unknown-2":
                (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch("Error: the oauth2 authenticator rejected our request to authenticate you", "error");
                break;
            case "unknown-3":
                (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch("Error: unknown error, could be a server, or network issue", "error");
                break;
            case "not-registered":
                (0, $0566dfdfd66639f1$export$2e2bcd8739ae039).dispatch("Error: you're not registered in the system, contact the administrator if you think this is a mistake", "error");
                break;
        }
    }
    return $0f32c2d6739d5745$var$root;
};


const [$8f6a480bb40b134f$var$el, $8f6a480bb40b134f$var$refs] = (0, $a6df9c40ba402dc9$export$3d7cd8ed57263b30)();
function $8f6a480bb40b134f$var$render() {
    const url = new URL(window.location.href);
    $8f6a480bb40b134f$var$refs.page.innerHTML = "";
    if ("/" === url.pathname) $8f6a480bb40b134f$var$refs.page.append((0, $212038711ef1a1fe$export$2e2bcd8739ae039)());
    else if ("/login" === url.pathname) $8f6a480bb40b134f$var$refs.page.append((0, $0f32c2d6739d5745$export$2e2bcd8739ae039)());
    else window.location.href = "/";
}
document.body.append($8f6a480bb40b134f$var$el("div", {
    ref: "page",
    class: "page"
}));
document.body.append((0, $0566dfdfd66639f1$export$2e2bcd8739ae039).root);
window.addEventListener("load", $8f6a480bb40b134f$var$render);
window.addEventListener("popstate", $8f6a480bb40b134f$var$render);
document.addEventListener("click", (event)=>{
    if (event.target.dataset["to"] === "spa") {
        event.preventDefault();
        (0, $a6df9c40ba402dc9$export$751f361fd4ccee93)(event.target.href);
    }
});


//# sourceMappingURL=ui.bf25a92a.js.map
